"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ProcessEnvObfuscationGuard_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessEnvObfuscationGuard = void 0;
const inversify_1 = require("inversify");
const ObfuscatingGuardResult_1 = require("../../../enums/node/ObfuscatingGuardResult");
const NodeGuards_1 = require("../../../node/NodeGuards");
let ProcessEnvObfuscationGuard = ProcessEnvObfuscationGuard_1 = class ProcessEnvObfuscationGuard {
    static isProcessEnvMemberExpression(node) {
        if (!NodeGuards_1.NodeGuards.isMemberExpressionNode(node)) {
            return false;
        }
        return (NodeGuards_1.NodeGuards.isIdentifierNode(node.object) &&
            node.object.name === 'process' &&
            NodeGuards_1.NodeGuards.isIdentifierNode(node.property) &&
            node.property.name === 'env' &&
            !node.computed);
    }
    static isPartOfProcessEnvChain(node) {
        if (ProcessEnvObfuscationGuard_1.isProcessEnvMemberExpression(node)) {
            return true;
        }
        const parentNode = node.parentNode;
        if (parentNode && NodeGuards_1.NodeGuards.isMemberExpressionNode(parentNode)) {
            if (ProcessEnvObfuscationGuard_1.isProcessEnvMemberExpression(parentNode.object)) {
                return true;
            }
            if (ProcessEnvObfuscationGuard_1.isProcessEnvMemberExpression(parentNode)) {
                return true;
            }
        }
        return false;
    }
    check(node) {
        return ProcessEnvObfuscationGuard_1.isPartOfProcessEnvChain(node)
            ? ObfuscatingGuardResult_1.ObfuscatingGuardResult.Ignore
            : ObfuscatingGuardResult_1.ObfuscatingGuardResult.Transform;
    }
};
exports.ProcessEnvObfuscationGuard = ProcessEnvObfuscationGuard;
exports.ProcessEnvObfuscationGuard = ProcessEnvObfuscationGuard = ProcessEnvObfuscationGuard_1 = __decorate([
    (0, inversify_1.injectable)()
], ProcessEnvObfuscationGuard);
